import React from 'react';
import "./TitleSecondary.scss";

const TitleSecondary = ({ children, align }) => {
    return (
        <h2 className="title-secondary" style={{textAlign: `${align}`}}>
            {children}
        </h2>
    )
}

export default TitleSecondary;
